import { BrowserCacheLocation, LogLevel, PublicClientApplication } from "@azure/msal-browser";

export const ALLOWED_DOMAINS = ["myivp.com.my", "ivpaero.com"];
export const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE;

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin + "/",
    postLogoutRedirectUri: window.location.origin + "/",
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii && level === LogLevel.Error) console.error(message);
      },
    },
  },
});

export const loginRequest = { scopes: ["openid", "profile", apiScope] };

export const getPortalAccessToken = async () => {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (!account) return null;
  try {
    const res = await msalInstance.acquireTokenSilent({ scopes: [apiScope], account });
    return res.accessToken;
  } catch {
    return null;
  }
};
